import { FormStore, GlobalStore, GridStore } from "@roc/feature-app-core";
import { isNil } from "@roc/feature-utils";
import { action, flow, makeObservable, observable } from 'mobx';


const propertyForm = {
  fields: {
    address: {
      value: null,
      error: null,
      rule: '',
    },
    city: {
      value: null,
      error: null,
      rule: '',
    },
    state: {
      value: null,
      error: null,
      rule: '',
    },
    zipCode: {
      value: null,
      error: null,
      rule: '',
    },
    county: {
      value: null,
      error: null,
      rule: '',
    },
    parcel_number: {
      value: null,
      error: null,
      rule: '',
    },
    rooms: {
      value: null,
      error: null,
      rule: '',
    },
    bedrooms: {
      value: null,
      error: null,
      rule: '',
    },
    full_bathrooms: {
      value: null,
      error: null,
      rule: '',
    },
    half_bathrooms: {
      value: null,
      error: null,
      rule: '',
    },
    area: {
      value: null,
      error: null,
      rule: '',
    },
    condition_tag: {
      value: null,
      error: null,
      rule: '',
    },
    lot_size: {
      value: null,
      error: null,
      rule: '',
    },
    taxes: {
      value: null,
      error: null,
      rule: '',
    },
    hoa_fees: {
      value: null,
      error: null,
      rule: '',
    },
    parking_type: {
      value: null,
      error: null,
      rule: '',
    },
    price: {
      value: null,
      error: null,
      rule: '',
    },
    rent: {
      value: null,
      error: null,
      rule: '',
    },
    sqft_rent: {
      value: null,
      error: null,
      rule: '',
    },
    sqft_price: {
      value: null,
      error: null,
      rule: '',
    },
    year_built: {
      value: null,
      error: null,
      rule: '',
    },

    property_type_group: {
      value: null,
      error: null,
      rule: '',
    },
    subject_zoning: {
      value: null,
      error: null,
      rule: '',
    },
    property_status: {
      value: null,
      error: null,
      rule: '',
    },
    sale_type: {
      value: null,
      error: null,
      rule: '',
    },
    original_list_date: {
      value: null,
      error: null,
      rule: '',
    },
    original_list_price: {
      value: null,
      error: null,
      rule: '',
    },
    last_sale_date: {
      value: null,
      error: null,
      rule: '',
    },
    last_sale_price: {
      value: null,
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class EditSubjectPropertyFormStore extends FormStore {
  public globalStore: GlobalStore;
  areEditFieldsOpened: boolean;

  constructor(globalStore: GlobalStore) {
    super({ ...propertyForm }, globalStore);
    this.areEditFieldsOpened = false;

    makeObservable(this, {
      getEditSubjectProperty: action
    });
  }


  loadSubjectProperty(record) {
    this.reset();
    this.loadForm(record);
  }

  getEditSubjectProperty() {
    try {
      const editPropertyFields = this.getFormValues()

      const {
        rooms,
        bedrooms,
        full_bathrooms,
        half_bathrooms,
        area,
        condition_tag,
        lot_size,
        taxes,
        year_built,
        property_type_group,

      } = editPropertyFields;



      const fields = {
        "ROOMS": this.parseToNumber(rooms),
        "BEDROOMS": this.parseToNumber(bedrooms),
        "FULL_BATHS": this.parseToNumber(full_bathrooms),
        "HALF_BATHS": this.parseToNumber(half_bathrooms),
        "AREA": this.parseToNumber(area),
        "CONDITION_TAG": condition_tag,
        "LOTSIZE": this.parseToNumber(lot_size),
        "ASSESSOR_TAX": this.parseToNumber(taxes),
        "YEARBUILT": this.parseToNumber(year_built),
        "PROPERTY_TYPE_GROUP": property_type_group
      };

      const editProperty = {
      };

      for (const [key, value] of Object.entries(fields)) {
        if (!isNaN(value) && !isNil(value)) {
          editProperty[key] = parseInt(value);
        } else if (!isNil(value) && value != '') {
          editProperty[key] = value;
        }
      }
      return editProperty;
    }
    catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while saving property values',
      });
      return false;
    }
  }

  parseToNumber(value) {
    if (value == null) return null;

    if (typeof value === "number") return value;

    if (typeof value === "string") {
      // Remove commas and trim whitespace
      const cleaned = value.replace(/,/g, "").trim();
      const parsed = parseFloat(cleaned);
      return isNaN(parsed) ? null : parsed;
    }
    return null; // any other type
  }

}